app.controller("CardByProgramController", ["$scope", "$q", "StSubject", "StaticData", "ProgramService", "Selection", "Users", "Students", "$uibModal", "ConfirmModal", "$stateParams", "toastr", "usSpinnerService",
    function ($scope, $q, StSubject, StaticData, ProgramService, Selection, Users, Students, $uibModal, ConfirmModal, $stateParams, toastr, usSpinnerService) {
        $scope.student = {};
        $scope.allCredits = 0;
        $scope.totalItems = 0;
        $scope.semester = 'სემესტრი';
        $scope.studentSemester = null;
        $scope.subNameOrCode = null;
        $scope.program = null;
        $scope.filtered = [];
        $scope.lastSemesterCredits = $stateParams.lastSemesterCredits;
        $scope.subjectStates1 = [{studentState: 'passed', name: 'ჩაბარებული'}, {studentState: 'failed', name: 'ჩაჭრილი'},
                                 {studentState: 'current', name: 'მიმდინარე'}];
        $scope.subjectStates2 = [{studentState: 'blocked', name: 'დაბლოკილი'}, {studentState: 'critical', name: 'კრიტიკული'},
                                 {studentState: 'important', name: 'მნიშვნელოვანი'}, {studentState: 'normal ', name: 'ზოგადი'}];

        StaticData.getItemsByKey("container_types").then(function (data) {
            $scope.containerTypes = data;
            $scope.subjectTypes = [{name: "ტიპი"}].concat(data);;
            $scope.containerTypesMap = _.keyBy($scope.containerTypes, '_id');
        });

        $scope.$watch('subNameOrCode', function (val) {
            filterSubjects();
        }, true);

        $scope.$watch('semester', function (val) {
            filterSubjects();
        }, true);

        $scope.$watch('subjectType', function (val) {
            filterSubjects();
        }, true);

        Users.profile($stateParams.studentId).then(function (data) {
            return $scope.student = data
        }).then(function (st) {
            $scope.studentSemester = st.info.semester;
            ProgramService.fetchOne(st.program).then(function (program) {
                $scope.program = program;
                $scope.semesters = ['სემესტრი', 'სემესტრის გარეშე'].concat(_.range(1, program.semesters + 1));
            });
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.selectSubject = function (subject) {
            Selection.sessions(subject.subjectActivation._id).then(function (groups) {
                $uibModal.open({
                    controller: "AddStudentSelectionController",
                    templateUrl: _pb + 'admin/selection/add-student-to-subject.html',
                    size: "md",
                    scope: $scope,
                    backdrop: 'static',
                    resolve: {
                        params: function () {
                            return {
                                student: $scope.student,
                                subjectActivation: subject.subjectActivation._id,
                                subjectName: subject.name,
                                sessions: groups,
                                close: true
                            };
                        }
                    }
                }).result.then(function () {
                    loadPage($stateParams.page);
                });
            });
        };

        $scope.getInfo = function (state) {
            if (state.studentState === 'important') return 'საგანი, პროგრამის მიხედვით, გასავლელია მიმდინარე სემესტრში';
            if (state.studentState === 'critical') return 'საგანი, პროგრამის მიხედვით, გასავლელი იყო წინა სემესტრებში';
            if (state.studentState === 'blocked') return 'საგანი დაბლოკილია წინაპირობის გამო ან კრედიტების რაოდენობა არ არის საკმარისი';
            if (state.studentState === 'normal') return 'საგნის არჩევა შესაძლებელია';
        };

        $scope.getPopover = function (subject) {
            var state = subject.studentState;
            if (state === 'blocked' && !subject.blockers) {
                return 'კრედიტების რაოდენობა არ არის გავლილი ' + subject.preCredits;
            }
            if (state === 'blocked' && subject.blockers) {
                var message = 'დაბლოკილია, წინაპირობების გამო:\n';
                for (var i in subject.blockers) {
                    var blocker = subject.blockers[i];
                    message += '"' + blocker.name + '" - ' + blocker.subject.code + '\n';
                }
                return message;
            }
        };

        function filterSubjects() {
            $scope.filtered = $scope.subjects;
            if ($scope.subNameOrCode) {
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return subject.name.indexOf($scope.subNameOrCode) !== -1
                        || subject.subject.code.indexOf($scope.subNameOrCode) !== -1
                });
            }
            if ($scope.semester !== 'სემესტრი') {
                var check = $scope.semester === 'სემესტრის გარეშე' ? null : $scope.semester;
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return check ? subject.semester === parseInt(check) : !subject.semester;
                });
            }
            if ($scope.subjectType) {
                var check = $scope.subjectType;
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return check ? subject.type === check : !subject.type;
                });
            }

            $scope.semesterSubjects = _($scope.filtered).groupBy('semester').value();
            $scope.keys = _.keys($scope.semesterSubjects);
        }

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");

            ProgramService.getStudentSubjects({
                studentId: $stateParams.studentId
            }).then(function (data) {
                $scope.subjects = data;

                $scope.allCredits = _(data)
                    .filter(function (subject) {
                        return subject.studentState === 'passed'
                    })
                    .sumBy(function (subject) {
                        return subject.credits;
                    });

                getFreeCredits();
                filterSubjects();
                usSpinnerService.stop("root");
            });
        }

        var getFreeCredits = function () {
            $scope.freeCredits = $scope.lastSemesterCredits > 30 ? (75 - $scope.lastSemesterCredits) : 45;


            $scope.currentCredits = _($scope.subjects)
                .filter(function (subject) {
                    return subject.studentState === 'current'
                })
                .sumBy(function (subject) {
                    return subject.credits;
                });

            $scope.freeCredits -= $scope.currentCredits;
        };

        $scope.applyFilter = function () {
            var semester;

            if ($scope.semester == 'სემესტრი') {
            }
            else if ($scope.semester == 'სემესტრის გარეშე') {
                semester = null;
                $scope.semesterSubjects = {null: $scope.semesterSubjects[semester]};
            }
            else {
                semester = $scope.semester;
                $scope.semesterSubjects = {semester: $scope.semesterSubjects[semester]};
            }

            $scope.keys = _.keys($scope.semesterSubjects);
        };

        $scope.subjectStateClass = function (subject) {
            var stateClass = 'none-subject';
            if (subject.studentState === 'passed') stateClass = 'passed-subject';
            if (subject.studentState === 'current') stateClass = 'current-subject';
            if (subject.studentState === 'failed') stateClass = 'failed-subject';
            if (subject.studentState === 'blocked') stateClass = 'blocked-subject-state';

            var rowClass = '';
            if (subject.studentState === 'critical') rowClass = 'danger';
            if (subject.studentState === 'important') rowClass = 'warning';
            return stateClass + " " + rowClass;
        };

        $scope.removeSubject = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "არჩეული საგნის წაშლა",
                message: "გსურთ   " + subject.name + "-ის არჩეული საგნის წაშლა?"
            }).result.then(function () {
                Selection.removeSelection(subject.studentSubject._id)
                    .then(function () {
                        toastr.success('', 'არჩეული საგანი წაშლილია');
                        loadPage($scope.currentPage);
                    });
            });
        };

        $scope.showSelectionButton = function (subject) {
            var notShowOn = ['passed', 'blocked', 'current'];
            return $scope.freeCredits>0 && $scope.freeCredits>=subject.credits && subject.subjectActivation && notShowOn.indexOf(subject.studentState) === -1;
        }
    }
]);
